import { clone, isEqual } from 'lodash';
import moment from 'moment';
import { Subject } from 'rxjs';
import * as i0 from "@angular/core";
/**
 * @deprecated
 */
var ReportFilterState = /** @class */ (function () {
    function ReportFilterState() {
        var _this = this;
        this.defaultOpenedInterval = {
            openedAt_gte: moment().subtract('1', 'month').startOf('days').format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
            openedAt_lte: moment().endOf('days').format('YYYY-MM-DDTHH:mm:ss.SSSZ')
        };
        this.onChangeFilter = new Subject();
        this.onClearFilter = new Subject();
        this.isFilterOn = new Subject();
        this.query = clone(this.defaultOpenedInterval);
        this.onChangeFilter.subscribe(function () {
            var queryWithoutDefaultValues = clone(_this.query);
            if (queryWithoutDefaultValues.openedAt_lte === _this.defaultOpenedInterval.openedAt_lte) {
                delete queryWithoutDefaultValues.openedAt_lte;
            }
            if (queryWithoutDefaultValues.openedAt_gte === _this.defaultOpenedInterval.openedAt_gte) {
                delete queryWithoutDefaultValues.openedAt_gte;
            }
            return _this.isFilterOn.next(!isEqual(queryWithoutDefaultValues, {}));
        });
    }
    ReportFilterState.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ReportFilterState_Factory() { return new ReportFilterState(); }, token: ReportFilterState, providedIn: "root" });
    return ReportFilterState;
}());
export { ReportFilterState };
